var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('button',{on:{"click":function($event){return _vm.down()}}},[_vm._v("下载")]),_c('el-form',{attrs:{"label":"证件照片","prop":"idImage"}},[_c('input',{attrs:{"type":"file"},on:{"change":_vm.ss}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }